export const FETCH_REST_LIST_REQUEST = 'FETCH_REST_LIST_REQUEST';
export const FETCH_REST_LIST_SUCCESS = 'FETCH_REST_LIST_SUCCESS';
export const FETCH_REST_LIST_FAILURE = 'FETCH_REST_LIST_FAILURE';
export const FETCH_REST_LIST_RESET = 'FETCH_REST_LIST_RESET';
